'use client';

import React, { useState } from 'react';
import { usePrivy } from '@privy-io/react-auth';
import { useAtomValue } from 'jotai';
import HeaderDelegationModal from '@/app/components/Modals/HeaderDelegationModal';
import ProposalModal from '@/app/components/Modals/ProposalModal';
import { userDataAtom } from '@/app/atoms/userData';
import { tokenInfoAtom } from '@/app/atoms/token';
import useDelegatesLoading from '@/app/hooks/useDelegatesLoading';

const Header = () => {
  const [delegateModalIsOpen, setDelegateModalIsOpen] = useState(false);
  const [openThresholdModal, setOpenThresholdModal] = useState(false);
  const userData = useAtomValue(userDataAtom);
  const tokenInfo = useAtomValue(tokenInfoAtom);
  const { loading } = useDelegatesLoading();
  const [activeModalDelegate, setActiveModalDelegate] = useState<`0x${string}`>('0x');

  const handleDelegate = () => {
    setDelegateModalIsOpen(true);
  };

  return (
    <div className="mt-2 max-sm:text-center border border-neutral-700 py-4 sm:rounded-md relative">
      <div className="px-4 text-sm flex flex-col mb-4 sm:mb-0 sm:flex-row justify-between">
        <div className="flex-1 sm:pr-4 py-2 text-pretty">
          The official Governance Site for KARRATco. Committed to building and supporting
          a vibrant gaming, entertainment, and AI ecosystem for developers.
        </div>
        <div className="min-w-fit flex gap-4 md:gap-2 flex-col lg:flex-row">
          <button
            className={`py-2 px-4 rounded-md text-sm max-h-[40px] flex items-center justify-center ${
              loading
                ? 'cursor-not-allowed text-neutral-200 bg-neutral-700 hover:bg-neutral-700'
                : 'bg-link hover:bg-hover cursor-pointer text-btntext hover:text-btnhover'
            }`}
            disabled={loading}
            onClick={() => setOpenThresholdModal(true)}
          >
            Create proposal
          </button>

          <button
            onClick={handleDelegate}
            className={`py-2 px-4 rounded-md text-sm max-h-[40px] flex items-center justify-center ${
              loading
                ? 'cursor-not-allowed text-neutral-200 bg-neutral-700 hover:bg-neutral-700'
                : 'bg-darkbtn hover:bg-darkbtnhover cursor-pointer text-btntext hover:text-btnhover'
            }`}
            disabled={loading}
          >
            Delegate
          </button>
        </div>
      </div>
      <div className="flex flex-col justify-between sm:max-w-fit w-full">
        <div className="flex justify-center mt-2 max-sm:mx-auto sm:pl-4 gap-4 flex-wrap">
          <div className="text-xxs font-bold py-1 px-3 bg-neutral-950 rounded-full">
            Ethereum
          </div>
          <div className="text-xxs font-bold py-1 px-3 bg-neutral-950 rounded-full">
            ERC20
          </div>
          {tokenInfo && (
            <div className="text-xxs font-bold py-1 px-3 bg-neutral-950 rounded-full text-start sm:text-center whitespace-nowrap">
              {tokenInfo.totalSupply} Supply
            </div>
          )}
        </div>
      </div>

      {delegateModalIsOpen && (
        <HeaderDelegationModal
          isOpen={!!delegateModalIsOpen}
          onClose={() => {
            setActiveModalDelegate('0x');
            setDelegateModalIsOpen(false);
          }}
          userData={userData}
          activeModalDelegate={activeModalDelegate}
          setActiveModalDelegate={setActiveModalDelegate}
        />
      )}
      {openThresholdModal && (
        <ProposalModal
          isOpen={openThresholdModal}
          onClose={() => {
            setOpenThresholdModal(false);
          }}
        />
      )}
    </div>
  );
};

export default Header;
